import { Inject, Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { TablePropertiesConstants } from '../../core/constants/table-properties.constant';

@Pipe({
    name: 'tableDataFormat'
})
export class TableDataFormatPipe implements PipeTransform {
    constructor(
        private cookies: CookieService,
        // tslint:disable-next-line: ban-types
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    transform(data: any, columnDef: string): any {
        if (columnDef === TablePropertiesConstants.SENDER || columnDef === TablePropertiesConstants.ASSIGNEE) {
            const name = data ? this.getFirstMiddleAndLastName(data) : 'N/A';
            return name;
        } else if (data == 'undefined') {
            return '-';
        } else {
            return data;
        }
    }

    getFirstMiddleAndLastName(data: string) {
        const str = data.split(' ');
        return str.length >= 4 ? str[0] + ' ' + str[1] + ' ' + str[str.length - 1] : data;
    }
}
